import React from "react";
import styled from "styled-components";
import { Form, Row, Col } from "antd";
import { useSelector } from "react-redux";

import { UserOutlined } from "@ant-design/icons";
import { updateInvoice as updateInvoiceApi } from "../helper/utils/api/invoice";
import moment from "moment";

import {
  Input,
  Select,
  DatePicker,
  Button,
  Typography,
  TextArea,
  Section,
} from "../core";
import { MixStyle } from "../styles";
const Notify_Utils = require("../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;
const EditInvoice = ({ form, onCreate, onCancel, inoiceId: { id } }) => {
  const [updatedInvoice, setUpdatedInvoice] = React.useState({});
  const clothQuality = useSelector(
    (state) => state.clothQualityReducer.clothQuality
  );
  let hsCode = useSelector((state) => state.hsCode.hs_code);

  const Invoice = useSelector((state) => state.contractReducer.invoices).filter(
    (items) => {
      return items.invoice_id === id;
    }
  )[0];
  const unFormateDate = moment(Invoice?.invoice_date);
  console.log("unFormateDate", unFormateDate);
  const value = {
    ...Invoice,
    invoice_date: unFormateDate,
  };
  const onValuesChange = (changedValues, valuse) => {
    setUpdatedInvoice((prev) => ({
      ...prev,
      contract_id: value?.contract_id,
      contract_type: value?.contract_type,
      company_id: value?.company_id,
      buyer_id: value?.buyer_id,
    }));

    if (changedValues.invoice_no) {
      setUpdatedInvoice((prev) => ({
        ...prev,
        invoice_no: changedValues.invoice_no,
      }));
    } else if (changedValues.invoice_date) {
      setUpdatedInvoice((prev) => ({
        ...prev,
        invoice_date: changedValues.invoice_date,
      }));
    } else if (changedValues.cloth_quality_id) {
      setUpdatedInvoice((prev) => ({
        ...prev,
        cloth_quality_id: changedValues.cloth_quality_id,
      }));
    } else if (changedValues.hs_code) {
      setUpdatedInvoice((prev) => ({
        ...prev,
        hs_code: changedValues.hs_code,
      }));
    } else if (changedValues.invoice_note) {
      setUpdatedInvoice((prev) => ({
        ...prev,
        invoice_note: changedValues.invoice_note,
      }));
    } else {
      setUpdatedInvoice((prev) => ({
        ...prev,
      }));
    }
  };
  const onFinish = async (fieldsValue) => {
    const length = Object.keys(updatedInvoice).length;
    if (length === 0) {
      onCancel();
      return;
    }
    const payload = { ...updatedInvoice };
    if (payload.invoice_date?.format) {
      payload.invoice_date = payload.invoice_date.format("YYYY-MM-DD");
    }
    try {
      await updateInvoiceApi(id, payload);
      onCreate();
      onCancel();
    } catch (error) {
      console.log("edit invoice error", error);
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Error While Edit Invoice"
      );
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <Section padding="20px">
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={value}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Invoice #"
              name="invoice_no"
              rules={[
                {
                  required: true,
                  message: "Please Enter Invoice No",
                },
              ]}
            >
              <Input placeholder="Invoice #" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Invoice Date"
              name="invoice_date"
              rules={[
                {
                  required: true,
                  message: "Please Set Invoice invoice_date!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Cloth Quality"
              name="cloth_quality_id"
              rules={[
                {
                  required: true,
                  message: "Please Enter Cloth Quality",
                },
              ]}
            >
              <Select
                placeholder="Reed * Pick / Warp * Weft = width″ Type"
                type="qualities"
                prefixIcon={<UserOutlined />}
                Options={clothQuality ? clothQuality : []}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="HS Code"
              name="hs_code"
              rules={[
                {
                  required: true,
                  message: "Please Select HS code",
                },
              ]}
            >
              <Select
                placeholder="HS Code "
                prefixIcon={<UserOutlined />}
                type="hsCode"
                Options={hsCode ? hsCode : []}
              />
              {/* <Input placeholder="HS Code" /> */}
            </Form.Item>
          </Col>
          <Col md={24}>
            <Form.Item
              label="Invoice Note "
              name="invoice_note"
              rules={[
                {
                  required: false,
                  message: "Please Enter Invoice Note",
                },
              ]}
            >
              <TextArea />
            </Form.Item>
          </Col>

          <Col xs={12} sm={12}>
            <Row type="flex" justify="space-around">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Update Invoice"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
              <Col sm={10}>
                <Button
                  bg="#404E67"
                  onClick={() => {
                    onCancel();
                    form.resetFields();
                  }}
                >
                  <Typography
                    text="Cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Section>
  );
};

export default EditInvoice;
